module.exports = __webpack_public_path__ + "img/icon-trash.0705c38c.svg";